import { defaultIconProps } from 'components/common/icons'
import type { DefaultIconProps } from 'components/common/icons'

export const Heart = ({
  size = defaultIconProps.size,
  className = defaultIconProps.className,
}: DefaultIconProps) => (
  <svg
    width={size}
    height={size && size * 0.9}
    viewBox="0 0 86 78"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 27.9935C0 13.4321 9.5788 0 25.72 0C33.2328 0 38.8104 3.21884 43 8.04184C47.1896 3.21884 52.7672 0 60.28 0C76.4212 0 86 13.4321 86 27.9935C86 40.6401 80.1408 50.7881 72.0844 58.8493C64.066 66.8721 53.7284 72.9825 44.342 77.6777C43.4972 78.1001 42.5028 78.1001 41.658 77.6777C32.2717 72.9825 21.9338 66.8721 13.9157 58.8493C5.85924 50.7881 0 40.6401 0 27.9935Z"
    />
  </svg>
)
